(function() {
    $(document).ready(function() {
        $('.js24OverlayLink').each(function() {

            const content = $(this);

            let popstateHash = null;
            let popstateFunction = null;

            if (window.history && window.history.pushState && content.data('hash') !== undefined) {
                popstateHash = content.data('hash');
                popstateFunction = function() {
                    $.fancybox.close();
                    $(this).off('popstate', popstateFunction);
                };
            }

            const parameters = {

                type: (content.data('type') ? content.data('type') : 'ajax'),

                touch: false,

                afterShow: function() {
                    if (popstateFunction !== null) {
                        window.history.pushState(popstateHash, null, './#' + popstateHash);
                        $(window).on('popstate', popstateFunction);
                    }
                },

                afterClose: function() {
                    if (popstateFunction !== null && location.hash === '#' + popstateHash) {
                        window.history.back();
                    }
                },
            };

            if (content.data('src') !== undefined) {
                parameters.href = content.data('src');
            }

            if (content.data('class') !== undefined) {
                parameters.baseClass = content.data('class');
            }

            if (content.data('type') === 'iframe') {

                parameters.toolbar = false;
                parameters.smallBtn = true;

                parameters.iframe = {

                    // Preload iframe before displaying it
                    // This allows to calculate iframe content width and height
                    // (note: Due to "Same Origin Policy", you can't get cross domain data).
                    preload: true,

                    // Custom CSS styling for iframe wrapping element
                    // You can use this to set custom iframe dimensions
                    //css: {},

                    // Iframe tag attributes
                    attr: {
                        scrolling: 'auto',
                    },
                };
            }

            content.fancybox(parameters);
        });
    });
})();
